import { cva, type VariantProps } from "cva";
import { twMerge } from "tailwind-merge";

type Props = {
  children?: React.ReactNode;
  className?: string;
} & VariantProps<typeof styles> &
  React.HTMLAttributes<HTMLDivElement>;

const styles = cva({
  base: "rounded-xl",
  variants: {
    theme: {
      none: "bg-transparent backdrop-blur-none",
      default: "colors-glass backdrop-blur-glass",
      border: "border border-theme-outline-variant",
    },
  },
  defaultVariants: {
    theme: "default",
  },
});

export function Card({ children, className, theme, ...props }: Props) {
  return (
    <div
      className={twMerge(
        styles({
          theme,
        }),
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
